module.exports = __webpack_public_path__ + "static/img/meeting_3.9198d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/meeting_3.jpg
// module id = 6I7x
// module chunks = 3